import Head from "next/head"
import { JobSearch } from "components/JobSearch/JobSearch"
import { useTranslations } from "use-intl"
import { generateMetaTags } from "utils/generateMetaTags"

export function JobPage({
  whichTranslation,
  which,
  query,
  locale,
  atlasRef,
  isTester,
}) {
  const t = useTranslations(whichTranslation)

  return (
    <>
      <Head>
        <title>{t("meta.title")} | SeasonalJobs.dol.gov</title>
        <meta name="description" content={t("meta.description")} />
        {generateMetaTags({
          title: t("meta.title"),
          description: t("meta.description"),
        })}
      </Head>
      <JobSearch
        which={which}
        query={query}
        locale={locale}
        atlasRef={atlasRef}
        isTester={isTester}
      />
    </>
  )
}
